import React, { Component } from "react";
import { injectIntl, FormattedMessage } from "react-intl";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import Breadcrumb from "../breadcrumb/Breadcrumb";
import {
  Form,
  Input,
  Button,
  Icon,
  Popconfirm,
  Alert,
  Checkbox,
  // Tabs,
  Radio,
  Row,
  Col,
  Spin
} from "antd";
import { sendNotification } from "../../utils/index";
import {
  createFolder,
  editFolder,
  deleteFolder,
  moveFolder,
  shareFolder,
  shareFolderReset
} from "../../actions/ClientAction";
import Helper from "../helper/Helper";
import { getBreadCrumbs } from "../../utils";
import BunkeyAPI from "../../api/BunkeyAPI";
import { RichTextEditor } from "../rich-text-editor/RichTextEditor";
import { getNewPermission } from "../../utils/index";
import { fetchUsersToMentionAll } from "../../api/GroupApi";
import { Select } from "antd";
import { isEmail } from "../../utils/index";
import "./crudfolder.css";

// const { TabPane } = Tabs;
const { TextArea } = Input;
const { Option } = Select;

const spinnerStyle = {
  textAlign: "center",
  borderRadius: 4,
  marginBottom: 20,
  padding: "30px 50px",
  margin: "20px 0"
};
export class CRUDFolder extends Component {
  constructor(props) {
    super(props);

    this.myInputCopyLink = React.createRef();
    this.state = {
      folder: null,
      folderId: null,
      folderDestination: null,
      emails: [],
      name: "",
      message: "",
      hasEmailError: false,
      breadcrumbState: "",
      showPasswordInputs: false,
      addPassword: "",
      confirmPassword: "",
      moveTab: false,
      bunker: true,
      isBunker: null,
      longDescription: "",
      tagProtocol: "",
      tagProtocolLength: "",
      editAction: "rename",
      loadingButtonLink: false,
      showCopyLink: false,
      copyLink: "",
      isFetchingUsers: false,
      users: [],
      errorFetchingUsers: null,
      plainOptions: ["10", "30", "60", "90", "120"],
      selectedOption: "10",
      showSpinnerEmail: true
    };
  }

  componentDidMount() {
    const { folderselect, breadcrumb, editAction, action } = this.props;
    const regex = /(<([^>]+)>)/gi;
    const htmlEntities = /&#{0,1}[a-z0-9]+;/gi;

    if (folderselect) {
      this.setState({
        folderId: folderselect,
        breadcrumbState: this.handleProcessBreadCrumbs(folderselect),
        bunker: false
      });

      if (breadcrumb) {
        const folder = breadcrumb.find(r => r._id === folderselect);
        this.setState({
          folder,
          isBunker:
            (folder && folder.parents && folder.parents.length) > 1
              ? false
              : true
        });

        if (folder && folder.parents && folder.parents.length === 1) {
          this.setState({
            longDescription: folder.longDescription
          });
        } else {
          const tagContent =
            folder && folder.tagProtocol ? folder.tagProtocol : null;
          const result = tagContent
            ? tagContent.replace(regex, "").replace(htmlEntities, "")
            : "";
          this.setState({
            tagProtocol: tagContent,
            tagProtocolLength: result.trim().length
          });
        }
      }
    }
    if (action && action === "edit" && editAction) {
      const folder = breadcrumb.find(r => r._id === folderselect);
      this.setState({
        editAction: editAction
      });
      if (editAction === "tags_protocol") {
        const tagContent =
          folder && folder.tagProtocol ? folder.tagProtocol : null;
        const result = tagContent
          ? tagContent.replace(regex, "").replace(htmlEntities, "")
          : "";
        this.setState({
          tagProtocol: tagContent,
          tagProtocolLength: result.trim().length
        });
      }
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      folderselect,
      isInFolderAction,
      error,
      data,
      action,
      isShared,
      intl,
      shareFolderReset,
      breadcrumb
    } = this.props;
    const { editAction } = this.state;
    const { folderId: prevFolderId } = prevState;
    const { folderId } = this.state;
    //
    if (prevProps.folderselect !== folderselect) {
      const folder = breadcrumb.find(r => r._id === folderselect);
      this.setState({
        folder,
        folderId: folderselect,
        breadcrumbState: this.handleProcessBreadCrumbs(folderselect)
      });
    }
    //
    if (!isInFolderAction && prevProps.isInFolderAction !== isInFolderAction) {
      this.props.handleHideCRUDFolder();
    }
    if (!isInFolderAction && error && prevProps.error !== error) {
      sendNotification(
        "error",
        intl,
        intl.formatMessage({ id: "not_process_folder" })
      );
    }
    //
    if (
      (prevProps.isInFolderAction !== isInFolderAction && !isInFolderAction) ||
      (data && prevProps.data !== data)
    ) {
      let description = "";
      switch (action) {
        case "create":
          description = intl.formatMessage({ id: "created_folder_notif" });
          break;
        case "delete":
          description = intl.formatMessage({ id: "deleted_folder_notif" });
          break;
        case "edit":
          description = intl.formatMessage({ id: "edited_folder_notif" });
          break;

        default:
          break;
      }
      this.setState({
        folderId: folderselect,
        folderDestination: null,
        breadcrumbState: "",
        name: ""
      });
      if (description !== "") {
        this.setState({
          folderId: folderselect
        });
        if (editAction !== "move")
          sendNotification("success", intl, description, 1);
      }
    }
    //
    if (isShared && prevProps.isShared !== isShared) {
      sendNotification(
        "success",
        intl,
        intl.formatMessage({ id: "notification_shared_folder" })
      );

      this.setState(
        {
          folderId: folderselect,
          folderDestination: null,
          breadcrumbState: "",
          message: "",
          name: ""
        },
        shareFolderReset
      );
    }
    //
    if (prevProps.isShared !== isShared) {
      this.setState({
        emails: []
      });
    }
    //
    if (action === "share" && folderId !== prevFolderId) {
      this.tryToFetchUsers();
    }
  }

  handleProcessBreadCrumbs = folderselect => {
    const breadcrumb = getBreadCrumbs(folderselect);
    if (breadcrumb && breadcrumb.length > 0) {
      return breadcrumb
        .filter(r => r.id !== folderselect)
        .map(r => r.name)
        .join("/");
    } else {
      return "";
    }
  };

  handleFolderSelect = folderId => {
    const { breadcrumb } = this.props;

    this.setState({
      folderId,
      breadcrumbState: this.handleProcessBreadCrumbs(folderId)
    });

    if (breadcrumb) {
      const folder = breadcrumb.find(a => a._id === folderId);
      this.setState({
        isBunker: folder && folder.parents && folder.parents.length === 1
      });

      if (folder && folder.parents && folder.parents.length === 1) {
        this.setState({
          longDescription: folder.longDescription,
          tagProtocol: ""
        });
      } else if (folder && folder.tagProtocol) {
        this.setState({
          tagProtocol: folder.tagProtocol
        });
      }
    }
  };

  handleFolderDestinationSelect = folderDestination => {
    this.setState({
      folderDestination
    });
  };

  handleOnChangeName = e => {
    this.setState({
      name: e.target.value
    });
  };

  handleActionFolder = e => {
    const {
      folderId,
      name,
      isBunker,
      emails,
      message,
      hasEmailError,
      bunker,
      showPasswordInputs,
      confirmPassword,
      longDescription,
      tagProtocol,
      editAction,
      folderDestination,
      addPassword,
      selectedOption
    } = this.state;
    const {
      workclient,
      action,
      root,
      folderselect,
      user,
      intl,
      newMatrix
    } = this.props;
    const isOperator = user.role !== "admin" && user.clientRole !== "admin";
    e.preventDefault();

    switch (action) {
      case "create":
        if (name) {
          // Si es operador:
          if (isOperator) {
            if (tagProtocol && folderId) {
              if (getNewPermission(folderId, newMatrix, "createFolder")) {
                this.props.createFolder(
                  workclient,
                  folderId,
                  name,
                  root,
                  folderselect,
                  "",
                  tagProtocol,
                  this.props.handleHideCRUDFolder
                );
              } else {
                sendNotification(
                  "warning",
                  intl,
                  intl.formatMessage({ id: "permission_denied" })
                );
              }
            } else {
              if (!folderId) {
                sendNotification(
                  "error",
                  intl,
                  intl.formatMessage({ id: "must_select_folder" })
                );
              } else {
                sendNotification(
                  "error",
                  intl,
                  intl.formatMessage({ id: "invalid_tag_protocol" })
                );
              }
            }
          } else {
            // Si es Admin:
            if (bunker) {
              // Crear Bunker
              longDescription
                ? this.props.createFolder(
                    workclient,
                    root,
                    name,
                    root,
                    folderselect,
                    longDescription,
                    "",
                    this.props.handleHideCRUDFolder
                  )
                : sendNotification(
                    "error",
                    intl,
                    intl.formatMessage({ id: "invalid_bunker_description" })
                  );

              return;
            } else {
              // Crear subcarpeta
              if (folderId) {
                tagProtocol
                  ? this.props.createFolder(
                      workclient,
                      folderId,
                      name,
                      root,
                      folderselect,
                      "",
                      tagProtocol,
                      this.props.handleHideCRUDFolder
                    )
                  : sendNotification(
                      "error",
                      intl,
                      intl.formatMessage({ id: "invalid_tag_protocol" })
                    );

                return;
              } else {
                sendNotification(
                  "error",
                  intl,
                  intl.formatMessage({ id: "must_select_folder" })
                );
              }
            }
          }
        } else {
          sendNotification(
            "error",
            intl,
            intl.formatMessage({ id: "must_enter_valid_folder_name" })
          );
        }
        break;

      case "edit":
        switch (editAction) {
          // Renombrar
          case "rename":
            // Si selecciono una carpeta para renombrar
            if (folderId) {
              const canEditFolder =
                user.clientRole !== "admin" && user.role !== "admin"
                  ? getNewPermission(folderId, newMatrix, "editFolder")
                  : true;
              if (canEditFolder) {
                name
                  ? this.props.editFolder(
                      workclient,
                      folderId,
                      name,
                      root,
                      folderselect,
                      undefined,
                      undefined,
                      this.props.handleHideCRUDFolder
                    )
                  : sendNotification(
                      "error",
                      intl,
                      intl.formatMessage({ id: "must_enter_valid_folder_name" })
                    );
              } else {
                sendNotification(
                  "warning",
                  intl,
                  intl.formatMessage({ id: "permission_denied" })
                );
              }
            } else {
              // Si no hay carpeta, notificación
              sendNotification(
                "error",
                intl,
                intl.formatMessage({ id: "must_select_folder" })
              );
            }
            break;

          // Mover
          case "move":
            // Si se selecciona la misma carpeta en origen y destino
            if (
              folderId === folderDestination &&
              folderId !== null &&
              folderDestination !== null
            ) {
              sendNotification(
                "error",
                intl,
                intl.formatMessage({ id: "must_select_different" })
              );
              return;
            }
            // Si no se selecciono ninguna carpeta
            if (folderId === null && folderDestination === null) {
              sendNotification(
                "error",
                intl,
                intl.formatMessage({ id: "no_folder_selected" })
              );
              return;
            }

            // Si se selecciono carpeta de origen
            if (folderId) {
              const canMoveFolder =
                user.clientRole !== "admin"
                  ? getNewPermission(folderId, newMatrix, "moveFolder")
                  : true;
              const canMoveFolderDestination =
                user.clientRole !== "admin"
                  ? getNewPermission(folderDestination, newMatrix, "moveFolder")
                  : true;

              if (canMoveFolder && canMoveFolderDestination) {
                // Si no hay carpeta de destino y el usuario es Admin la mueve a los Bunkers
                if (
                  !folderDestination &&
                  user.role === "admin" &&
                  user.clientRole === "admin"
                ) {
                  this.props.moveFolder(
                    workclient,
                    folderId,
                    root,
                    folderselect,
                    root,
                    intl,
                    this.props.handleHideCRUDFolder
                  );
                  // Si hay carpeta de destino y el usuario es Admin
                } else if (
                  folderDestination &&
                  user.role === "admin" &&
                  user.clientRole === "admin"
                ) {
                  this.props.moveFolder(
                    workclient,
                    folderId,
                    folderDestination,
                    folderselect,
                    root,
                    intl,
                    this.props.handleHideCRUDFolder
                  );
                  // Si no hay carpeta de destino y el usuario es Operador   (Victor Smith)
                } else if (
                  !folderDestination &&
                  user.role === "operator" &&
                  user.clientRole === "admin"
                ) {
                  this.props.moveFolder(
                    workclient,
                    folderId,
                    root,
                    folderselect,
                    root,
                    intl,
                    this.props.handleHideCRUDFolder
                  );
                  // Si hay carpeta de destino y el usuario es Admin (Victor Smith)
                } else if (
                  folderDestination &&
                  user.role === "operator" &&
                  user.clientRole === "admin"
                ) {
                  this.props.moveFolder(
                    workclient,
                    folderId,
                    folderDestination,
                    folderselect,
                    root,
                    intl,
                    this.props.handleHideCRUDFolder
                  );
                  //
                } else if (
                  !folderDestination &&
                  user.role === "operator" &&
                  user.clientRole === "operator"
                ) {
                  sendNotification(
                    "warning",
                    intl,
                    intl.formatMessage({ id: "select_valid_destination" })
                  );
                  return;
                  // Si no es un bunker, hay carpeta de destino y el usuario es Operador
                } else if (
                  !isBunker &&
                  folderDestination &&
                  user.role === "operator"
                ) {
                  this.props.moveFolder(
                    workclient,
                    folderId,
                    folderDestination,
                    folderselect,
                    root,
                    intl,
                    this.props.handleHideCRUDFolder
                  );
                } else {
                  sendNotification(
                    "warning",
                    intl,
                    intl.formatMessage({ id: "permission_denied" })
                  );
                  return;
                }
              } else {
                sendNotification(
                  "warning",
                  intl,
                  intl.formatMessage({ id: "permission_denied" })
                );
              }
            } else {
              sendNotification(
                "warning",
                intl,
                intl.formatMessage({ id: "must_select_source_folder" })
              );
              return;
            }
            break;

          // Protocolo Tags
          case "tags_protocol":
            if (folderId) {
              const canEdit =
                user.clientRole !== "admin" && user.role !== "admin"
                  ? getNewPermission(folderId, newMatrix, "editFolder")
                  : true;
              if (canEdit) {
                if (!tagProtocol) {
                  sendNotification(
                    "error",
                    intl,
                    intl.formatMessage({ id: "invalid_tag_protocol" })
                  );
                } else {
                  this.props.editFolder(
                    workclient,
                    folderId,
                    name,
                    root,
                    folderselect,
                    longDescription ? longDescription : "",
                    tagProtocol,
                    this.props.handleHideCRUDFolder
                  );
                }
              } else {
                sendNotification(
                  "warning",
                  intl,
                  intl.formatMessage({ id: "permission_denied" })
                );
              }
            } else {
              // Si no hay carpeta para editar, notificación
              sendNotification(
                "error",
                intl,
                intl.formatMessage({ id: "must_select_folder" })
              );
            }

            break;
          default:
            break;
        }
        break;

      case "move":
        // Si se selecciona la misma carpeta en origen y destino
        if (
          folderId === folderDestination &&
          folderId !== null &&
          folderDestination !== null
        ) {
          sendNotification(
            "error",
            intl,
            intl.formatMessage({ id: "must_select_different" })
          );
          return;
        }
        // Si no se selecciono ninguna carpeta
        if (folderId === null && folderDestination === null) {
          sendNotification(
            "error",
            intl,
            intl.formatMessage({ id: "no_folder_selected" })
          );
          return;
        }
        // Si se selecciono carpeta de origen
        if (folderId) {
          const canMoveFolderId =
            user.clientRole !== "admin" && user.role !== "admin"
              ? getNewPermission(folderId, newMatrix, "moveFolder")
              : true;
          const canMoveFolderDestination =
            user.clientRole !== "admin" && user.role !== "admin"
              ? getNewPermission(folderDestination, newMatrix, "moveFolder")
              : true;

          if (canMoveFolderId && canMoveFolderDestination) {
            // Si no hay carpeta de destino y el usuario es Admin la mueve a los Bunkers
            if (!folderDestination && user.role === "admin") {
              this.props.moveFolder(
                workclient,
                folderId,
                root,
                folderselect,
                root,
                intl
              );
              // Si hay carpeta de destino y el usuario es Admin
            } else if (folderDestination && user.role === "admin") {
              this.props.moveFolder(
                workclient,
                folderId,
                folderDestination,
                folderselect,
                root,
                intl
              );
              // Si no hay carpeta de destino y el usuario es Operador
            } else if (!folderDestination && user.role === "operator") {
              sendNotification(
                "warning",
                intl,
                intl.formatMessage({ id: "select_valid_destination" })
              );
              return;
              // Si hay carpeta de destino y el usuario es Operador
            } else if (folderDestination && user.role === "operator") {
              this.props.moveFolder(
                workclient,
                folderId,
                folderDestination,
                folderselect,
                root,
                intl
              );
            }
          } else {
            sendNotification(
              "warning",
              intl,
              intl.formatMessage({ id: "permission_denied" })
            );
          }
        } else {
          sendNotification(
            "warning",
            intl,
            intl.formatMessage({ id: "must_select_source_folder" })
          );
          return;
        }
        break;

      case "delete":
        if (folderId) {
          const canDelete =
            user.clientRole !== "admin" && user.role !== "admin"
              ? getNewPermission(folderId, newMatrix, "deleteFolder")
              : true;
          // modificado por Victor Smith
          if (canDelete) {
            this.props.deleteFolder(
              workclient,
              folderId,
              root,
              folderselect,
              this.props.history,
              this.props.handleHideCRUDFolder
            );
          } else {
            sendNotification(
              "warning",
              intl,
              intl.formatMessage({ id: "permission_denied" })
            );
          }
        } else {
          sendNotification(
            "error",
            intl,
            intl.formatMessage({ id: "must_select_folder_delete" })
          );
        }
        break;

      case "share":
        // Si no hay carpeta seleccionada para compartir
        if (!folderId) {
          sendNotification(
            "warning",
            intl,
            intl.formatMessage({ id: "must_select_folder_share" })
          );
          // Pero agrego contraseña
          if (showPasswordInputs) {
            // Y los inputs estan vacios
            if (addPassword === "" && confirmPassword === "") {
              sendNotification(
                "error",
                intl,
                intl.formatMessage({ id: "must_enter_password" })
              );
            }
          }
          if (!emails.length > 0) {
            sendNotification(
              "warning",
              intl,
              intl.formatMessage({ id: "must_least_email_address" })
            );
            return;
          }
          // Si hay una carpeta seleccionada
        } else {
          const canShare =
            user.clientRole !== "admin" && user.role !== "admin"
              ? getNewPermission(folderId, newMatrix, "shareFolder")
              : true;

          if (canShare) {
            // Y el email no es válido
            if (hasEmailError) {
              this.setState({
                hasEmailError: false
              });
              return;
            } else {
              // Si no hay email
              if (!emails.length > 0) {
                sendNotification(
                  "warning",
                  intl,
                  intl.formatMessage({ id: "must_least_email_address" })
                );
                return;
                // Si hay email
              } else {
                // Pero agrego contraseña
                if (showPasswordInputs) {
                  // y ambas calzan y no estan vacias
                  if (
                    addPassword === confirmPassword &&
                    confirmPassword !== "" &&
                    addPassword !== ""
                  ) {
                    this.props.shareFolder(
                      workclient,
                      folderId,
                      emails,
                      user,
                      confirmPassword,
                      message,
                      intl
                    );
                    // Si estan vacias
                  } else if (addPassword === "" && confirmPassword === "") {
                    sendNotification(
                      "error",
                      intl,
                      intl.formatMessage({ id: "must_enter_password" })
                    );
                    // Si no calzan
                  } else
                    sendNotification(
                      "error",
                      intl,
                      intl.formatMessage({ id: "not_equal_passwords" })
                    );
                  // Si no agrego contraseña
                } else {
                  this.props.shareFolder(
                    workclient,
                    folderId,
                    emails,
                    user,
                    "",
                    message,
                    intl,
                    parseInt(selectedOption)
                  );
                }
              }
            }
          } else {
            sendNotification(
              "warning",
              intl,
              intl.formatMessage({ id: "permission_denied" })
            );
          }
        }
        break;

      default:
        break;
    }
  };

  handleKeyPressed = e => {
    if (e.key === "Enter") this.handleActionFolder(e);
  };

  handleEmails = tag => {
    this.setState({
      emails: tag.tags.map(r => {
        return r;
      })
    });
  };

  handleInputMessagge = e => {
    this.setState({
      message: e.target.value
    });
  };

  handleError = hasError => {
    this.setState({
      hasEmailError: hasError
    });
  };

  handleCancelMoveFolder = () => {
    this.props.handleHideCRUDFolder();
    this.setState({
      folderId: null,
      folderDestination: null
    });
  };

  handleCancelCRUD = () => {
    const { action } = this.props;
    if (action === "share") {
      this.setState({
        message: ""
      });
    } else {
      this.setState({
        name: ""
      });
    }
    this.props.handleHideCRUDFolder();
  };

  handleShowPasswordInputs = () => {
    const { showPasswordInputs } = this.state;
    this.setState({
      showPasswordInputs: !showPasswordInputs
    });
  };

  handleAddPass = e => {
    this.setState({
      addPassword: e.target.value
    });
  };

  handleConfirmPass = e => {
    this.setState({
      confirmPassword: e.target.value
    });
  };

  handleSendLinkShareFolder = (
    folderId,
    user,
    workclient,
    changeSelectedOption
  ) => {
    const { intl, newMatrix } = this.props;
    const { selectedOption } = this.state;
    if (!folderId) {
      sendNotification(
        "warning",
        intl,
        intl.formatMessage({ id: "must_select_folder_share" })
      );
    } else {
      const canShare =
        user.clientRole !== "admin" && user.role !== "admin"
          ? getNewPermission(folderId, newMatrix, "shareFolder")
          : true;
      if (canShare) {
        this.setState(
          {
            loadingButtonLink: true
          },
          () =>
            BunkeyAPI({
              url: `/shared/getDownloadLink`,
              method: "POST",
              data: {
                object: folderId,
                user: user._id,
                client: workclient,
                password: "",
                expiresIn: changeSelectedOption
                  ? parseInt(changeSelectedOption)
                  : parseInt(selectedOption)
              }
            })
              .then(resp => {
                this.setState({
                  copyLink: resp.data,
                  showCopyLink: true,
                  loadingButtonLink: false
                });

                this.myInputCopyLink.current.focus();
                this.myInputCopyLink.current.setSelectionRange(0, 9999);
              })
              .catch(err => {
                sendNotification(
                  "error",
                  intl,
                  intl.formatMessage({ id: "error_copy_link" })
                );
              })
        );
      } else {
        sendNotification(
          "warning",
          intl,
          intl.formatMessage({ id: "permission_denied" })
        );
      }
    }
  };

  handleMoveTab = key => {
    this.setState({
      moveTab: true,
      editAction: key
    });
  };

  handleCreate = e => {
    this.setState({
      bunker: e.target.value
    });
  };

  handleCancelEditProtocol = () => {
    this.props.handleHideCRUDFolder();
  };

  handleBunkerOnChange = e => {
    const { editAction } = this.props;
    if (editAction === "tags_protocol") {
      const regex = /(<([^>]+)>)/gi;
      const htmlEntities = /&#{0,1}[a-z0-9]+;/gi;
      const result =
        e.target.value && e.target.value !== ""
          ? e.target.value.replace(regex, "").replace(htmlEntities, "")
          : "";
      this.setState({
        [e.target.name]: e.target.value,
        tagProtocolLength: result.trim().length
      });
    } else {
      this.setState({
        [e.target.name]: e.target.value
      });
    }
  };

  handleTagProtocol = value => {
    const regex = /(<([^>]+)>)/gi;
    const htmlEntities = /&#{0,1}[a-z0-9]+;/gi;
    const result = value.replace(regex, "").replace(htmlEntities, "");

    this.setState({
      tagProtocol: value,
      tagProtocolLength: result.trim().length
    });
  };

  tryToFetchUsers = () => {
    this.setState({ isFetchingUsers: true, users: [] }, this.fetchUsers);
  };

  fetchUsers = () => {
    this.setState({ showSpinnerEmail: true });
    const { workclient } = this.props;
    // const { folderId } = this.state;

    fetchUsersToMentionAll(workclient, 1)
      .then(res => {
        // const { adminUsers, operatorUsers } = res.data;
        // const usersMentions = [...adminUsers, ...operatorUsers];
        const usersMentions = res.data;
        const usersMentionsSorted = usersMentions.sort(
          (firstUser, secondUser) => {
            if (firstUser.name.toLowerCase() < secondUser.name.toLowerCase())
              return -1;
            if (firstUser.name.toLowerCase() === secondUser.name.toLowerCase())
              return 0;
            return 1;
          }
        );

        this.setState({
          users: usersMentionsSorted,
          isFetchingUsers: false,
          errorFetchingUsers: null,
          showSpinnerEmail: false
        });
      })
      .catch(err => {
        this.setState({
          errorFetchingUsers: err,
          isFetchingUsers: false,
          users: [],
          showSpinnerEmail: false
        });
      });
  };

  handleChangeEmail = values => {
    const onlyValidEmails = values.filter(email => isEmail(email));
    this.setState({ emails: onlyValidEmails });
  };

  render() {
    const {
      folderId,
      breadcrumbState,
      folderDestination,
      name,
      message,
      addPassword,
      confirmPassword,
      showPasswordInputs,
      bunker,
      isBunker,
      longDescription,
      tagProtocol,
      tagProtocolLength,
      // moveTab,
      loadingButtonLink,
      copyLink,
      showCopyLink,
      users,
      emails,
      plainOptions,
      selectedOption,
      showSpinnerEmail,
      folder
    } = this.state;
    const {
      isInFolderAction,
      action,
      user,
      newColor,
      intl,
      workclient,
      canEdit,
      editAction
      // canMove
    } = this.props;
    const isOperator = user.role !== "admin" && user.clientRole !== "admin";
    const editPermission = isOperator ? canEdit : true;
    const optionsUser = users.map(user => {
      return (
        <Option key={user._id} value={user.email} uid={user._id}>
          {`${user.name} (${user.email})`}
        </Option>
      );
    });
    const optionsSpinner = (
      <Option key={"spinner_loading"}>
        <div style={spinnerStyle}>
          <Spin spinning={true} />
        </div>
      </Option>
    );

    // console.log("folder", folder);

    return (
      <div>
        {action === "create" && (
          //Drawer Crear se divide entre Bunkers y Sub-Carpetas
          <Form>
            {!isOperator && (
              <Form.Item style={{ marginBottom: "5px" }}>
                <React.Fragment>
                  {/* Radio button para definir si se crea un Bunker o una Subcarpeta */}
                  <span>
                    {intl.formatMessage({ id: "create_folder_choose" })}:
                  </span>
                  <br />
                  <Radio.Group
                    onChange={this.handleCreate}
                    defaultChecked={bunker}
                    value={bunker}
                    size="small"
                  >
                    <Radio value={true}>Bunker</Radio>
                    <Radio value={false}>
                      {intl.formatMessage({ id: "sub_folder" })}
                    </Radio>
                  </Radio.Group>
                </React.Fragment>
              </Form.Item>
            )}
            {/* Bunker */}
            {bunker && !isOperator && (
              <Form.Item style={{ marginBottom: "0" }}>
                {/* Nombre */}
                <span>{intl.formatMessage({ id: "name" })}</span>
                <Input
                  value={name}
                  onChange={this.handleOnChangeName}
                  maxLength={75}
                  placeholder={intl.formatMessage({
                    id: "create_bunker_name_specifies"
                  })}
                />
                <span style={{ color: "#C3C2C1" }}>{name.length}/75</span>
              </Form.Item>
            )}
            {/* Descripción del Bunker */}
            {bunker && !isOperator && (
              <Form.Item>
                <span>{intl.formatMessage({ id: "post_description" })}</span>
                <TextArea
                  rows={4}
                  placeholder={intl.formatMessage({
                    id: "new_folder_description"
                  })}
                  name="longDescription"
                  maxLength={75}
                  value={longDescription}
                  onChange={this.handleBunkerOnChange}
                />
                {longDescription && (
                  <span style={{ color: "#C3C2C1" }}>
                    {longDescription.length}/75
                  </span>
                )}
              </Form.Item>
            )}
            {/* Subcarpeta */}
            {(!bunker || isOperator) && (
              <Form.Item style={{ marginBottom: "0" }}>
                {/* Nombre  */}
                <span>{intl.formatMessage({ id: "name" })}</span>
                <Input
                  value={name}
                  maxLength={75}
                  onChange={this.handleOnChangeName}
                  placeholder={intl.formatMessage({
                    id: "create_folder_name_specifies"
                  })}
                />
                <span style={{ color: "#C3C2C1" }}>{name.length}/75</span>
              </Form.Item>
            )}
            {/* Select subcarpetas */}
            {(!bunker || isOperator) && (
              <Form.Item style={{ marginBottom: "10px" }}>
                <Breadcrumb
                  title={intl.formatMessage({ id: "create_folder_select" })}
                  value={folderId}
                  placeholder={intl.formatMessage({
                    id: "create_folder_select"
                  })}
                  handleFolderSelect={this.handleFolderSelect}
                  changeFolder={false}
                  permissionAware={
                    user.clientRole === "admin" || user.role === "admin"
                      ? false
                      : true
                  }
                  permissionsArray={["createFolder"]}
                />
              </Form.Item>
            )}
            {/* Enriquecedor de texto para protocolo de tags */}
            {(!bunker || isOperator) && (
              <Form.Item>
                <span>{intl.formatMessage({ id: "tags_protocol" })}</span>
                <RichTextEditor
                  onType={this.handleTagProtocol}
                  placeholder={intl.formatMessage({
                    id: "tags_protocol_description"
                  })}
                  tagsProtocol={true}
                  tagProtocol={tagProtocol}
                  key={"tagProtocolEditor"}
                />
                <span style={{ color: "#C3C2C1" }}>{tagProtocolLength}</span>
              </Form.Item>
            )}
            {/* Boton crear */}
            <Button
              loading={isInFolderAction}
              type="primary"
              style={{ backgroundColor: newColor, borderColor: newColor }}
              onClick={this.handleActionFolder}
            >
              {intl.formatMessage({ id: "create" })}
              <Icon type="folder-add" />
            </Button>
            &emsp;
            {/* Cancelar */}
            <Button
              type="default"
              style={{ borderColor: newColor, color: newColor }}
              onClick={this.handleCancelCRUD}
            >
              <FormattedMessage id="cancel_button" />
              <Icon type="close" />
            </Button>
          </Form>
        )}

        {action === "edit" &&
          editPermission &&
          editAction &&
          editAction === "rename" && (
            <Form>
              <p className="rename-modal-label">
                {intl.formatMessage({ id: "crudfolder_rename_folder" })}
              </p>
              <Input type="text" disabled value={folder ? folder.name : ""} />
              <br />
              <div className="mt-1" style={{ marginBottom: "30px" }}>
                <p className="rename-modal-label">
                  {intl.formatMessage({ id: "new_create_folder_name" })}{" "}
                </p>
                <Input
                  value={name}
                  maxLength={75}
                  onChange={this.handleOnChangeName}
                  placeholder={intl.formatMessage({
                    id: "crudfolder_edit_enter"
                  })}
                />
              </div>
              {/* Botón renombrar */}
              <Row
                type={"flex"}
                justify={"space-between"}
                style={{ marginBottom: "36px" }}
              >
                <Button
                  size={"large"}
                  type={"primary"}
                  loading={isInFolderAction}
                  className="rename-modal-button accept"
                  onClick={this.handleActionFolder}
                >
                  {intl.formatMessage({ id: "rename" })}
                </Button>
                {/* Botón cancelar */}
                <Button
                  size={"large"}
                  type={"primary"}
                  ghost
                  onClick={this.handleCancelCRUD}
                  className="rename-modal-button cancel"
                >
                  <FormattedMessage id="cancel_button" />
                </Button>
              </Row>
            </Form>
          )}
        {action === "edit" &&
          editPermission &&
          editAction &&
          editAction === "move" && (
            <Form>
              <p className="rename-modal-label">
                {intl.formatMessage({
                  id: "crudfolder_folder_source_move"
                })}
              </p>
              <Input type="text" disabled value={folder ? folder.name : ""} />
              <br />
              <Form.Item style={{ marginTop: "10px" }}>
                <Breadcrumb
                  title={intl.formatMessage({
                    id: "breadcrumb_placeholder"
                  })}
                  placeholder={intl.formatMessage({
                    id: "crudfolder_move_indicates_destination"
                  })}
                  value={folderDestination}
                  permissionAware={
                    user.clientRole === "admin" || user.role === "admin"
                      ? false
                      : true
                  }
                  permissionsArray={["moveFolder"]}
                  handleFolderSelect={this.handleFolderDestinationSelect}
                />
              </Form.Item>
              <Form.Item>
                {!isOperator && (
                  <Alert
                    message={intl.formatMessage({ id: "warning" })}
                    description={intl.formatMessage({
                      id: "crudfolder_move_warnings_message"
                    })}
                    type="warning"
                    showIcon
                  />
                )}
              </Form.Item>
              <Form.Item>
                <Row type={"flex"} justify={"space-between"}>
                  <Button
                    size={"large"}
                    type={"primary"}
                    className="move-modal-button accept"
                    loading={isInFolderAction}
                    onClick={this.handleActionFolder}
                  >
                    <FormattedMessage id="move_asset" />
                  </Button>
                  <Button
                    size={"large"}
                    type={"primary"}
                    ghost
                    className="move-modal-button cancel"
                    onClick={this.handleCancelMoveFolder}
                  >
                    <FormattedMessage id="cancel_button" />
                  </Button>
                </Row>
              </Form.Item>
            </Form>
          )}
        {action === "edit" &&
          editPermission &&
          editAction &&
          editAction === "tags_protocol" && (
            <Form>
              <p className="tag-prot-modal-label">
                {intl.formatMessage({
                  id: "crudfolder_folder_source_tags"
                })}
              </p>
              <Input type="text" disabled value={folder ? folder.name : ""} />

              {/* Descripcion del Tooltip para Bunkers  */}
              {isBunker && (
                <Form.Item style={{ marginTop: "10px" }}>
                  <span>
                    {intl.formatMessage({ id: "tag-prot-modal-title" })}
                  </span>
                  <TextArea
                    rows={5}
                    placeholder={intl.formatMessage({
                      id: "indicate_new_description"
                    })}
                    name="tagProtocol"
                    maxLength={150}
                    value={tagProtocol}
                    autosize={false}
                    onChange={this.handleBunkerOnChange}
                    style={{ minHeight: "136px" }}
                  />
                  {/* {longDescription && (
                    <span style={{ color: "#C3C2C1" }}>
                      {longDescription.length}/150
                    </span>
                  )} */}
                  <p
                    className="tag-prot-modal-counter"
                    style={{ marginBottom: "15px" }}
                  >{`${tagProtocolLength}/150`}</p>
                </Form.Item>
              )}

              {/* Protocolo de tags para Subcarpetas  */}
              {!isBunker && (
                <Form.Item>
                  <span>{intl.formatMessage({ id: "tags_protocol" })}</span>
                  <RichTextEditor
                    onType={this.handleTagProtocol}
                    placeholder={intl.formatMessage({
                      id: "indicate_new_protocol"
                    })}
                    tagsProtocol={true}
                    tagProtocol={tagProtocol}
                    key={"tagProtocol"}
                  />
                  <span style={{ color: "#C3C2C1" }}>{tagProtocolLength}</span>
                </Form.Item>
              )}

              {/* Botón editar y cancelar */}
              <Form.Item style={{ marginBottom: 0 }}>
                <Row type={"flex"} justify={"space-between"}>
                  <Button
                    size={"large"}
                    type={"primary"}
                    className="tag-prot-modal-button accept"
                    onClick={this.handleActionFolder}
                  >
                    <FormattedMessage id="edit_asset" />
                  </Button>
                  <Button
                    size={"large"}
                    type={"primary"}
                    ghost
                    className="tag-prot-modal-button cancel"
                    onClick={this.handleCancelEditProtocol}
                  >
                    <FormattedMessage id="cancel_button" />
                  </Button>
                </Row>
              </Form.Item>
            </Form>
          )}

        {/* Drawer Mover que se muestra al operador solo si está permitido mover pero no editar. */}
        {isOperator && !canEdit && action === "move" && (
          <Form>
            <Form.Item>
              <span>
                {intl.formatMessage({
                  id: "crudfolder_indicates_source"
                })}
              </span>
              <Input type="text" disabled value={folder ? folder.name : ""} />
            </Form.Item>
            <Form.Item>
              <Breadcrumb
                title={intl.formatMessage({ id: "breadcrumb_placeholder" })}
                placeholder={intl.formatMessage({
                  id: "crudfolder_move_indicates_destination"
                })}
                value={folderDestination}
                permissionAware={
                  user.clientRole === "admin" || user.role === "admin"
                    ? false
                    : true
                }
                permissionsArray={["moveFolder"]}
                handleFolderSelect={this.handleFolderDestinationSelect}
              />
            </Form.Item>
            <Form.Item>
              {(user.role === "admin" || user.clientRole === "admin") && (
                <Alert
                  message={intl.formatMessage({ id: "warning" })}
                  description={intl.formatMessage({
                    id: "crudfolder_move_warnings_message"
                  })}
                  type="warning"
                  showIcon
                />
              )}
            </Form.Item>
            <Form.Item>
              <Button
                loading={isInFolderAction}
                type="primary"
                style={{ backgroundColor: newColor, borderColor: newColor }}
                onClick={this.handleActionFolder}
              >
                <FormattedMessage id="move_asset" />
                <Icon type="export" />
              </Button>
              &emsp;
              <Button
                type="default"
                style={{ borderColor: newColor, color: newColor }}
                onClick={this.handleCancelMoveFolder}
              >
                <FormattedMessage id="cancel_button" />
                <Icon type="close" />
              </Button>
            </Form.Item>
          </Form>
        )}

        {action === "delete" && (
          <Form>
            <Form.Item>
              {/* <Breadcrumb
                title={intl.formatMessage({ id: "crudfolder_delete_folder" })}
                value={folderId}
                placeholder={intl.formatMessage({ id: "delete_folder_select" })}
                handleFolderSelect={this.handleFolderSelect}
                changeFolder={false}
                permissionAware={
                  user.clientRole === "admin" || user.role === "admin"
                    ? false
                    : true
                }
                permissionsArray={["deleteFolder"]}
              /> */}
              <span>
                {intl.formatMessage({ id: "crudfolder_delete_folder" })}
              </span>
              <Input type="text" value={folder ? folder.name : ""} disabled />
            </Form.Item>
            {breadcrumbState !== "" && (
              <div
                data-show="true"
                className="ant-alert ant-alert-warning ant-alert-with-description"
                style={{ marginTop: 10, marginBottom: 25 }}
              >
                <i
                  aria-label="icon: exclamation-circle"
                  className="anticon anticon-exclamation-circle ant-alert-icon"
                >
                  <svg
                    viewBox="64 64 896 896"
                    className=""
                    data-icon="exclamation-circle"
                    width="1em"
                    height="1em"
                    fill="currentColor"
                    aria-hidden="true"
                    focusable="false"
                  >
                    <path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"></path>
                    <path d="M464 688a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm24-112h48c4.4 0 8-3.6 8-8V296c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8z"></path>
                  </svg>
                </i>
                <span className="ant-alert-message">
                  {intl.formatMessage({ id: "warning" })}
                </span>
                <span className="ant-alert-description">
                  {intl.formatMessage({ id: "delete_folder_confirm" })}{" "}
                  <b>{breadcrumbState}</b>
                </span>
              </div>
            )}
            <Row type={"flex"} justify={"space-between"}>
              <Popconfirm
                title={intl.formatMessage({
                  id: "second_delete_folder_confirm"
                })}
                onConfirm={this.handleActionFolder}
                okText={intl.formatMessage({ id: "delete_asset" })}
                cancelText={intl.formatMessage({ id: "cancel_button" })}
              >
                <Button
                  size={"large"}
                  type={"primary"}
                  loading={isInFolderAction}
                  className="delete-modal-button accept"
                >
                  {intl.formatMessage({ id: "delete_asset" })}
                </Button>
              </Popconfirm>
              <Button
                size={"large"}
                type={"primary"}
                ghost
                className="delete-modal-button cancel"
                onClick={this.props.handleHideCRUDFolder}
              >
                <FormattedMessage id="cancel_button" />
              </Button>
            </Row>
          </Form>
        )}

        {action === "share" && (
          <Form>
            <Form.Item>
              {/* <Breadcrumb
                title={intl.formatMessage({ id: "crudfolder_share_folder" })}
                placeholder={intl.formatMessage({
                  id: "crudfolder_share_select"
                })}
                value={folderId}
                handleFolderSelect={this.handleFolderSelect}
                changeFolder={false}
                permissionAware={
                  user.clientRole === "admin" || user.role === "admin"
                    ? false
                    : true
                }
                permissionsArray={["shareFolder"]}
              /> */}
              <span>
                {intl.formatMessage({ id: "crudfolder_share_folder" })}
              </span>
              <Input type="text" disabled value={folder ? folder.name : ""} />
            </Form.Item>
            <Form.Item
              label={intl.formatMessage({ id: "multi-share-share-days" })}
            >
              <Row style={{ width: "100%" }}>
                {plainOptions.map(item => {
                  return (
                    <Col span={4} key={item}>
                      <Checkbox
                        value={item}
                        onChange={value => {
                          if (selectedOption !== item && showCopyLink) {
                            this.handleSendLinkShareFolder(
                              folderId,
                              user,
                              workclient._id,
                              value.target.value
                            );
                          }
                          this.setState({
                            selectedOption: value.target.value
                          });
                        }}
                        checked={selectedOption === item}
                      >
                        {item}
                      </Checkbox>
                    </Col>
                  );
                })}
              </Row>
            </Form.Item>
            <Form.Item>
              <Button
                type="primary"
                loading={loadingButtonLink}
                style={{ backgroundColor: newColor, borderColor: newColor }}
                onClick={() =>
                  this.handleSendLinkShareFolder(folderId, user, workclient._id)
                }
              >
                {intl.formatMessage({ id: "generate_link" })}
              </Button>
            </Form.Item>
            {showCopyLink && (
              <Form.Item
                style={{
                  marginTop: "-21px"
                }}
              >
                <div style={{ display: "flex" }}>
                  <input
                    className="ant-input"
                    value={copyLink}
                    type="text"
                    ref={this.myInputCopyLink}
                  />
                  <Button
                    type="primary"
                    style={{
                      backgroundColor: newColor,
                      borderColor: newColor,
                      marginLeft: 10
                    }}
                    onClick={() => {
                      navigator.clipboard.writeText(copyLink);
                      sendNotification(
                        "success",
                        intl,
                        intl.formatMessage({ id: "link_copied" })
                      );
                      this.handleCancelCRUD();
                    }}
                  >
                    {intl.formatMessage({ id: "copy_link" })}
                  </Button>
                </div>
              </Form.Item>
            )}
            <Form.Item>
              {/* <TagsV2
                titleCustom={intl.formatMessage({ id: "add_email_adresses" })}
                placeholderCustom={intl.formatMessage({ id: "add_new_email" })}
                validateIsEmail={true}
                handleTags={this.handleEmails}
                handleError={this.handleError}
              /> */}

              <span>
                {intl.formatMessage({ id: "add_email" })}
                <Helper
                  title={"helper_title"}
                  content={"helper_share_asset_content"}
                  trigger={`click`}
                />
              </span>
              {
                <Select
                  mode="tags"
                  style={{ width: "100%" }}
                  onChange={this.handleChangeEmail}
                  tokenSeparators={[","]}
                  value={emails}
                >
                  {showSpinnerEmail && optionsSpinner}
                  {optionsUser}
                </Select>
              }
            </Form.Item>
            <Form.Item>
              <Checkbox onChange={this.handleShowPasswordInputs}>
                {intl.formatMessage({ id: "add_password" })}
                <Helper
                  title={"helper_title"}
                  content={"helper_add_password"}
                  trigger={`click`}
                />
              </Checkbox>
              {showPasswordInputs && (
                <Input.Group className="input-group">
                  <Input.Password
                    className="pass-input"
                    placeholder="Agregar Contraseña"
                    value={addPassword}
                    onChange={this.handleAddPass}
                  />
                  <Input.Password
                    className="pass-input"
                    placeholder="Confirmar Contraseña"
                    onBlur={this.handleOnBlur}
                    value={confirmPassword}
                    onChange={this.handleConfirmPass}
                  />
                </Input.Group>
              )}
            </Form.Item>
            <Form.Item>
              <TextArea
                placeholder={intl.formatMessage({ id: "message" })}
                rows="3"
                value={message}
                onChange={this.handleInputMessagge}
              />
            </Form.Item>
            <Row type={"flex"} justify={"space-between"}>
              <Button
                size={"large"}
                type={"primary"}
                loading={isInFolderAction}
                className="share-modal-button accept"
                onClick={this.handleActionFolder}
              >
                <FormattedMessage id="shared_share" />
              </Button>
              <Button
                size={"large"}
                type={"primary"}
                ghost
                className="share-modal-button cancel"
                onClick={this.handleCancelCRUD}
              >
                <FormattedMessage id="cancel_button" />
              </Button>
            </Row>
          </Form>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    workclient: state.client.workclient,
    folderselect: state.assetsExplore.folderselect,
    isInFolderAction: state.client.isInFolderAction,
    root: state.client.root,
    user: state.authUser.user,
    isFetching: state.client.isFetching,
    data: state.client.breadcrumb,
    isShared: state.client.isShared,
    newColor:
      state.authUser.user && state.authUser.user.color
        ? state.authUser.user.color
        : "#2E97CF",
    breadcrumb: state.client.breadcrumb,
    newMatrix: state.group.newMatrix
  };
};

const mapDispatchToProps = {
  createFolder,
  editFolder,
  deleteFolder,
  moveFolder,
  shareFolder,
  shareFolderReset
};

export default injectIntl(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(CRUDFolder))
);
